import * as React from 'react';

var Modal = require('react-bootstrap-modal');

export interface OwnProps {
}

export interface ConnectedState {
    show: boolean;
    azenURL: string;
}

export interface ConnectedDispatch {
    onSesionExpirada: () => void;
}

interface ZSesionExpiradaState {
    maxTimeInactiveSocket: number;
}

export class ZSesionExpirada extends React.Component<OwnProps & ConnectedState & ConnectedDispatch, ZSesionExpiradaState>
{
    private inactivityTimer: any = null;
    private activityEvents = ['mousedown', 'keydown', 'scroll', 'touchstart'];

    constructor(props: OwnProps & ConnectedState & ConnectedDispatch) {
        super(props);
        this.state = { maxTimeInactiveSocket: 0 };
    }

    componentDidMount() {
        this.fetchSessionTimeout();
    }

    componentWillUnmount() {
        this.clearInactivityTimer();
        this.removeActivityListeners();
    }

    fetchSessionTimeout = () => {
        const baseUrl = this.props.azenURL || '';
        const url = `${baseUrl.replace(/\/$/, '')}/api/config/session-timeout`;

        fetch(url)
            .then(res => res.json())
            .then((data: { maxTimeInactiveSocket: number }) => {
                if (data.maxTimeInactiveSocket > 0) {
                    this.setState({ maxTimeInactiveSocket: data.maxTimeInactiveSocket }, () => {
                        this.startInactivityMonitor();
                    });
                }
            })
            .catch(() => { /* config endpoint not available, skip timer */ });
    }

    startInactivityMonitor = () => {
        this.activityEvents.forEach(evt =>
            document.addEventListener(evt, this.resetInactivityTimer, true)
        );
        this.resetInactivityTimer();
    }

    resetInactivityTimer = () => {
        if (this.props.show) return;

        this.clearInactivityTimer();
        const timeoutMs = this.state.maxTimeInactiveSocket * 1000;
        this.inactivityTimer = setTimeout(() => {
            this.props.onSesionExpirada();
        }, timeoutMs);
    }

    clearInactivityTimer = () => {
        if (this.inactivityTimer) {
            clearTimeout(this.inactivityTimer);
            this.inactivityTimer = null;
        }
    }

    removeActivityListeners = () => {
        this.activityEvents.forEach(evt =>
            document.removeEventListener(evt, this.resetInactivityTimer, true)
        );
    }

    componentDidUpdate(prevProps: OwnProps & ConnectedState & ConnectedDispatch) {
        if (this.props.show && !prevProps.show) {
            this.clearInactivityTimer();
            this.removeActivityListeners();
        }
    }

    handleCerrar = () => {
        sessionStorage.clear();
        window.close();
        // Fallback: si el navegador bloquea window.close(), recargar
        window.location.href = window.location.origin;
    }

    render() {
        if (!this.props.show) {
            return (<span></span>);
        }

        return (
            <div className="static-modal">
                <Modal
                    show={true}
                    backdrop="static"
                    onHide={null}
                    aria-labelledby="sesion-expirada-modal"
                    className="zsesion-expirada-modal"
                >
                    <Modal.Body>
                        <div className="zsesion-expirada">
                            <div className="zsesion-expirada-icon">
                                <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="#337ab7" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                                    <circle cx="12" cy="12" r="10"></circle>
                                    <polyline points="12 6 12 12 16 14"></polyline>
                                </svg>
                            </div>
                            <h4 className="zsesion-expirada-title">Sesión Expirada</h4>
                            <p className="zsesion-expirada-msg">
                                Su sesión ha expirado por inactividad.
                                <br />
                                Por favor inicie la aplicación de nuevo.
                            </p>
                            <button
                                className="btn btn-primary zsesion-expirada-btn"
                                onClick={this.handleCerrar}
                            >
                                Aceptar
                            </button>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/modules/zaplicacion/components/ZSesionExpirada.tsx